<template>
  <div class="loading" v-if="mainStore().globalLoading"><i class="pi pi-spin pi-spinner spinner"></i></div>
  <div class="main" v-show="!mainStore().globalLoading">
    <Header/>
    <div class="desk">
      <div class="hidden md:block">
        <Menu/>
      </div>
      <div class="work-space">
        <router-view></router-view>
      </div>
    </div>
    <menu-bottom-mob/>
  </div>
</template>

<script>

import Header from "@/components/header";
import Menu from "@/components/menu";
import MenuBottomMob from "@/components/menuBottomMob";
import {mainStore} from "@/store/main";
import {getProfileApi} from "@/api/profile";
import {loadTranslations} from "@/locales/i18n";

export default {
  name: "layoutMain",
  components: {MenuBottomMob, Menu, Header},
  mounted() {
    this.getInfoProfile()
  },
  methods: {
    mainStore,
    getInfoProfile() {
      getProfileApi().then((resp) => {
        mainStore().setInfoProfile(resp.data)
        if (resp.data.language) {
          localStorage.setItem('locale', resp.data.language)
          loadTranslations(resp.data.language)
        }
      }, (error) => {
      })
    },
  }
}
</script>

<style scoped>
.loading {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .spinner {
    font-size: 80px;
    color: rgba(41, 112, 201, 0.32);
  }
}

.main {
  height: 100dvh;
  background-color: #F9FBFF;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.desk {
  display: flex;
  height: calc(100% - 80px);
}

.work-space {
  padding: 22px;
  width: calc(100% - 220px);
  height: 100%;
  overflow: auto;
}

@media screen and (max-width: 1365px) {
  .main {
    padding-top: 64px;
    padding-bottom: 0;
  }

  .desk {
    height: calc(100dvh - 64px - 54px);
    flex: none;
  }

  .work-space {
    width: 100%;
    height: 100%;
    padding: 14px 14px 24px 14px;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
}

</style>
